<template>
<div>
  <Destaques />
  <Emblemas />
  <Artigos />
</div>
</template>

<script>
import Destaques from "./parts/Destaques";
import Emblemas from "./parts/Emblemas";
import Artigos from "./parts/Artigos";

export default {
  name: "Home",
  components: {
    Destaques, Artigos, Emblemas
  }
}
</script>